module.exports = __webpack_public_path__ + "static/media/facebook.5374f54c.svg";